// extracted by mini-css-extract-plugin
module.exports = {"error100":"#FEE4E2","error400":"#F97066","error500":"#F04438","shadowXS":"0px 1px 2px rgba(16,24,40,0.05)"};